import { render, staticRenderFns } from "./StatNumber.vue?vue&type=template&id=8258bb52&"
import script from "./StatNumber.vue?vue&type=script&lang=js&"
export * from "./StatNumber.vue?vue&type=script&lang=js&"
import style0 from "./StatNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports